import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaRetencoesInicio: [],
    buscaRetencoesSucesso: ['retencoes'],
    buscaRetencoesErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
}

// Ação para busca completa
Creators.buscaRetencoes = filtro => {
    return dispatch => {
        dispatch(Creators.buscaRetencoesInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarRetencoes(filtro)
            .then(response => dispatch(Creators.buscaRetencoesSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaRetencoesErro(error)))
    }
}

const buscaRetencoesInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaRetencoesErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaRetencoesSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.retencoes, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RETENCOES_INICIO]: buscaRetencoesInicio,
    [Types.BUSCA_RETENCOES_ERRO]: buscaRetencoesErro,
    [Types.BUSCA_RETENCOES_SUCESSO]: buscaRetencoesSucesso,
})
